export default __webpack_public_path__ + "static/media/slide4.463f0bc5.jpg";